export default __webpack_public_path__ + "static/media/rotate.755b61a2.svg";